import { ofType } from 'redux-observable';
import { combineLatest, merge, of } from 'rxjs';
import { filter, map, mergeMap, take, withLatestFrom } from 'rxjs/operators';
import type { SpEpic } from 'shared/middlewares/epic/epicMiddleware.factory';
import { dynamicProductsRequested } from 'state/productsReferential/productsReferential.action';
import { getIsUserInternal, getUserFrontRights } from 'state/selectors';
import { workspaceTabsFetchRequested } from 'state/workspaces/workspace.actions';

export function navigateToDynamicWorkspaceEpic(): SpEpic {
  return (action$, state$) => {
    const firstNavigationToQuoteForm$ = action$.pipe(
      ofType('ROUTE_CHANGED'),
      filter(({ path }) => path === '/dynamic'),
    );

    const dashboardShown$ = action$.pipe(ofType('WORKSPACE_SHOW_DASHBOARD'));

    const userInfoReceived$ = action$.pipe(ofType('USER_CURRENT_RECEIVED'));
    const dynamicProductsLoaded$ = action$.pipe(ofType('DYNAMIC_PRODUCTS_LOADED', 'DYNAMIC_PRODUCTS_LOADING_FAILED'));

    return combineLatest([
      merge(firstNavigationToQuoteForm$, dashboardShown$),
      userInfoReceived$,
      dynamicProductsLoaded$,
    ]).pipe(
      withLatestFrom(state$),
      filter(([_, state]) => getUserFrontRights(state).quoteEnabled && getIsUserInternal(state)),
      take(1),
      map(() => workspaceTabsFetchRequested('dynamic')),
    );
  };
}

export function loadDynamicProductsEpic(): SpEpic {
  return (action$, state$) =>
    action$.pipe(
      ofType('USER_CURRENT_RECEIVED'),
      take(1),
      withLatestFrom(state$),
      filter(([action, state]) => action.userInfo.entitlements.quoteEnabled && getIsUserInternal(state)),
      mergeMap(() => of(dynamicProductsRequested())),
    );
}
